export default "__VITE_ASSET__DSCNHrum__"